module.exports = __webpack_public_path__ + "media/images/stage6-ff4768a7.png";